import axios from "axios";
import { apiBaseUrl } from "../../../helpers/UrlHelper";
import { handleError } from "../../../helpers/ErrorHelper";
import { debounce } from "../../../helpers/Debounce";

function _success(success) {
  return { type: "GET_SUPER_ADMIN_SITES_SUCCESS", success };
}

function _error(error) {
  return { type: "GET_SUPER_ADMIN_SITES_ERROR", error };
}

function _processing(processing) {
  return { type: "GET_SUPER_ADMIN_SITES_PROCESSING", processing };
}

function getSites(shouldDebounce = false) {
  return (dispatch, getState) => {
    dispatch(_processing(true));
    dispatch(_error(null));
    let { superAdminSiteList } = getState();
    let { params } = superAdminSiteList.data;

    const request = () =>
      axios({
        url: apiBaseUrl(`admin/sites`),
        method: "get",
        dataType: "json",
        params,
        headers: {
          Authorization: "Bearer " + localStorage.getItem(`Bearer`),
        },
      })
        .then(function (res) {
          dispatch(_success(res));
        })
        .catch(function (error) {
          handleError(error);
          dispatch(_error(error));
        })
        .finally(function () {
          dispatch(_processing(false));
        });

    debounce.makeRequest(request, shouldDebounce);
  };
}

export default getSites;
